import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from "../auth.service";
import {appRoutingEnum} from "@enums/appRoutingEnum";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class NonLoggedGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log(this.auth.getIsLogin());
    if (this.auth.getIsLogin()) {
      return this.router.parseUrl(appRoutingEnum.HOME);
    }
    return this.auth.getIsLoginFromStorage().pipe(
      map(isLogin => !isLogin ? true : this.router.parseUrl(appRoutingEnum.HOME)));
  }

}
